
import { Badge } from '@/components/ui/badge';

interface NuvemshopStatusBadgeProps {
  status: string;
}

export const NuvemshopStatusBadge = ({ status }: NuvemshopStatusBadgeProps) => {
  const variants = {
    active: 'default',
    inactive: 'secondary',
    error: 'destructive',
    configuring: 'outline'
  } as const;

  const labels = {
    active: 'Conectado',
    inactive: 'Desconectado',
    error: 'Erro',
    configuring: 'Configurando'
  };

  return (
    <Badge variant={variants[status as keyof typeof variants] || 'secondary'}>
      {labels[status as keyof typeof labels] || status}
    </Badge>
  );
};
